/**
 * Export utilities for CSV/data downloads
 */

type CsvRow = Record<string, string | number | boolean | null | undefined>;

/**
 * Convert data to CSV format and trigger download
 */
export function exportToCsv(
  data: CsvRow[],
  filename: string,
  columns?: { key: string; label: string }[],
) {
  if (data.length === 0) return;

  // Determine columns from first row if not provided
  const firstRow = data[0];
  const cols = columns ?? (firstRow ? Object.keys(firstRow).map((key) => ({ key, label: key })) : []);

  // Build CSV header
  const header = cols.map((c) => escapeCell(c.label)).join(',');

  // Build CSV rows
  const rows = data.map((row) =>
    cols.map((c) => escapeCell(String(row[c.key] ?? ''))).join(','),
  );

  const csv = [header, ...rows].join('\n');

  // Create blob and trigger download
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

function escapeCell(value: string): string {
  // If value contains comma, quote, or newline, wrap in quotes and escape inner quotes
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
